import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopHighlightActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/Highlight/HighlightBrowser")
	}

	render() {
		return (
			<Activity 
				name="ShopHighlight"
				RenderedComponent={this.RenderedComponent}
				context="ShopHighlight"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopHighlightActivity)
